export default function addPositionFilters(self, fields) {
  const PositionFields = {
    title: `Positions`,
    minimum: 1,
    maximum: 1,
    key: "join_position",
    asObject: true,
    type: "group",
    fields: [
      {
        title: "Total",
        minimum: 1,
        maximum: 1,
        key: "total",
        type: "integer",
        referenceType: "position",
      },
    ],
  };

  fields.push(PositionFields);
}
